import React from "react";

import { Tooltip } from "@blueprintjs/core";

import styles from "../VariantsTable.module.scss";
import { Icon } from "../../../../atoms/Icon";

export const INITIAL_COLUMNS = [
  {
    title: "SKU",
    placeholder: "SKU",
    stateKey: "sku",
    larger: true,
    rightElement: (
      <Tooltip
        popoverClassName={styles.skuInfoTooltip}
        content="
          A SKU is mandatory and helps you identify your product on 
          sales reports, even if the name of that product changes.
        "
        position="bottom"
      >
        <Icon name="info-sign" size={12} className={styles.skuInfoIcon} />
      </Tooltip>
    )
  },
  {
    title: "Stock",
    placeholder: "Unlimited",
    stateKey: "stock"
  },
  {
    title: "Price",
    placeholder: "29.99",
    stateKey: "price"
  },
  {
    placeholder: "Option Value",
    stateKey: "variantOption3",
    variantOption: true,
    title: ""
  }
];
